import { VSnackbar } from 'vuetify/lib/components/VSnackbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSnackbar,{staticClass:"ml-16 mt-5",attrs:{"color":"primary","rounded":"pill","top":""},model:{value:(_vm.addToCallStatus.show),callback:function ($$v) {_vm.$set(_vm.addToCallStatus, "show", $$v)},expression:"addToCallStatus.show"}},[_vm._v(" Calling "+_vm._s(_vm.addToCallStatus.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }